<ng-container *transloco="let t">
    <button (click)="onClick()" class="logo-button button-undecorated" [ngClass]="{'full-width': hasFullWidth()}"
        role="button">
        @if (logoSrc()) {
            <img [ngSrc]="logoSrc()!" fill priority id="store-logo" [ngClass]="{'align-center': alignCenter()}"
                [alt]="logoInfo().altText || displayedAltText()" (load)='onLoad()' />
        }
    </button>
</ng-container>